import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.object.assign";

var scope_0 = require('/home/runner/work/ventura/ventura/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1df5da46242d31c53c4d273856c6d26e.js')["default"];

var scope_1 = require('/home/runner/work/ventura/ventura/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/2ec4a4f463ac5ea64aa5d39d1734ef7a.js')["default"];

var scope_2 = require('/home/runner/work/ventura/ventura/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3833ae5467e61c3b1fd87779dbf3a7cd.js')["default"];

var scope_3 = require('/home/runner/work/ventura/ventura/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3b08f4c8e5eed4110fe5d84e88ae6d49.js')["default"];

var scope_4 = require('/home/runner/work/ventura/ventura/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3df4d02cee5ac940af36300fd6d2c68c.js')["default"];

var scope_5 = require('/home/runner/work/ventura/ventura/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/424e1d5da858e5b9b64f562fe8b9ea95.js')["default"];

var scope_6 = require('/home/runner/work/ventura/ventura/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/53b1b46750e33cce943cfb18f07dde18.js')["default"];

var scope_7 = require('/home/runner/work/ventura/ventura/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5f7a776e47660d2a32ee35558fa92523.js')["default"];

var scope_8 = require('/home/runner/work/ventura/ventura/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/6ade5410579374a3a17f974c8ab61d09.js')["default"];

var scope_9 = require('/home/runner/work/ventura/ventura/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/7cd03e0034315003fe05467457bd8cc5.js')["default"];

var scope_10 = require('/home/runner/work/ventura/ventura/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/af006119f5fb2910e936d073f2be5cb7.js')["default"];

var scope_11 = require('/home/runner/work/ventura/ventura/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c147affad69ad2b6e96fd39e6957c671.js')["default"];

var scope_12 = require('/home/runner/work/ventura/ventura/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/cce2ad3794f73555796fef5000594d9f.js')["default"];

var scope_13 = require('/home/runner/work/ventura/ventura/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d20ca80e44423fcd5fbea9406acfd0d5.js')["default"];

var scope_14 = require('/home/runner/work/ventura/ventura/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e7f8b8e44956aa78493ba4b710482aac.js')["default"];

var scope_15 = require('/home/runner/work/ventura/ventura/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js')["default"];

var scope_16 = require('/home/runner/work/ventura/ventura/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f591ec448d5eec61f73c114bb58af279.js')["default"];

var __DOCZ_DUMMY_EXPORT_DEFAULT = Object.assign({}, scope_0, scope_1, scope_2, scope_3, scope_4, scope_5, scope_6, scope_7, scope_8, scope_9, scope_10, scope_11, scope_12, scope_13, scope_14, scope_15, scope_16);

export default __DOCZ_DUMMY_EXPORT_DEFAULT;

if (typeof __DOCZ_DUMMY_EXPORT_DEFAULT !== 'undefined' && __DOCZ_DUMMY_EXPORT_DEFAULT && __DOCZ_DUMMY_EXPORT_DEFAULT === Object(__DOCZ_DUMMY_EXPORT_DEFAULT) && Object.isExtensible(__DOCZ_DUMMY_EXPORT_DEFAULT) && !__DOCZ_DUMMY_EXPORT_DEFAULT.hasOwnProperty('__filemeta')) {
  Object.defineProperty(__DOCZ_DUMMY_EXPORT_DEFAULT, '__filemeta', {
    configurable: true,
    value: {
      name: "__DOCZ_DUMMY_EXPORT_DEFAULT",
      filename: "node_modules/gatsby-plugin-mdx/loaders/mdx-scopes.js"
    }
  });
}

if (typeof __DOCZ_DUMMY_EXPORT_DEFAULT !== 'undefined' && __DOCZ_DUMMY_EXPORT_DEFAULT && __DOCZ_DUMMY_EXPORT_DEFAULT === Object(__DOCZ_DUMMY_EXPORT_DEFAULT) && Object.isExtensible(__DOCZ_DUMMY_EXPORT_DEFAULT) && !__DOCZ_DUMMY_EXPORT_DEFAULT.hasOwnProperty('__filemeta')) {
  Object.defineProperty(__DOCZ_DUMMY_EXPORT_DEFAULT, '__filemeta', {
    configurable: true,
    value: {
      name: "__DOCZ_DUMMY_EXPORT_DEFAULT",
      filename: "node_modules/gatsby-plugin-mdx/loaders/mdx-scopes.js"
    }
  });
}